import { useState } from 'react';
import Card from 'components/card';
import { HiX } from 'react-icons/hi';
import { videoTokenService } from 'views/services/videoTokenService';

type TProps = {
  onClose: () => void;
  data: { tokenId: string; creatorId: number; tokenSymbol: string };
  fetchData: () => Promise<void>;
};

const DeletePopUp = ({ onClose, data, fetchData }: TProps) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;

    if (value.trim().length > 0 && value.length <= 250) {
      setError('');
    } else if (value.trim().length === 0 || value.length > 250) {
      setError('Description should be less than 250 characters');
    } else {
      setError('');
    }

    setReason(value);
  };

  const handleDelete = async () => {
    await videoTokenService.deleteVideoToken({ ...data, reason });
    await fetchData();

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <Card className="relative rounded-xl bg-white p-8 shadow-lg min-w-[300px] max-w-[90%]">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-black">
          <HiX />
        </button>

        <div className="flex flex-col gap-4">
          <p className="text-lg font-bold">Delete video token</p>

          <p>Why do you want to delete this token?</p>

          <textarea
            value={reason}
            onChange={handleChange}
            className="p-2 border border-gray-300 rounded-md"
            placeholder="Enter your reason"
          />

          {error && <p className="text-red-500 w-[250px] text-sm">{error}</p>}

          <div className="flex justify-end">
            <button
              onClick={handleDelete}
              disabled={!!error || !reason}
              className="font-bold cursor-pointer text-red-500 disabled:text-red-300 disabled:cursor-not-allowed">
              Delete
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DeletePopUp;
